import { Configuration } from "@/api/clients/calculator";
import { addErrorInterceptors, defaultAxiosSettings } from "@/api/axiosConfigs/defaultAxiosConfig";
import axios from "axios";

export const ymGbsConfig = new Configuration({
  basePath: process.env.VUE_APP_YM_GBS_API_URL,
  baseOptions: defaultAxiosSettings,
});

export const ymGbsAxiosInstance = addErrorInterceptors(
  axios.create({
    baseURL: ymGbsConfig.basePath,
    ...defaultAxiosSettings,
  })
);